(function () {
  if (window.__puHubSpotFormsLoaded) return;
  window.__puHubSpotFormsLoaded = true;

  var endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/49394079/e42e331f-71bc-4399-8b6b-98b0d6a0cbdc';
  var allowedFields = ['firstname', 'lastname', 'email', 'mobilephone', 'im_interested_in', 'message'];
  var allowedInterests = ['Consultation', 'Oxygen therapy', 'Device purchase', 'Commercial partnership', 'Wellness programs', 'Other'];

  function getHubSpotCookie() {
    try {
      // HubSpot tracking loads for every visitor, so always link the submission to the visitor's HubSpot session.
      var match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (ignore) {
      return '';
    }
  }

  function normalisePhone(value) {
    var phone = String(value || '').trim();
    if (!phone) return '';
    phone = phone.replace(/[^\d+]/g, '');
    if (phone.indexOf('00') === 0) return '+' + phone.slice(2).replace(/\D/g, '');
    if (phone.charAt(0) === '+') return '+' + phone.slice(1).replace(/\D/g, '');
    phone = phone.replace(/\D/g, '');
    if (phone.charAt(0) === '0') return '+44' + phone.slice(1);
    if (phone.indexOf('44') === 0) return '+' + phone;
    return phone;
  }

  function setState(form, state, message) {
    var fields = form.querySelector('[data-pu-form-fields]');
    var success = form.querySelector('[data-pu-form-success]');
    var error = form.querySelector('[data-pu-form-error]');
    form.setAttribute('data-pu-form-state', state);

    if (fields) fields.hidden = state === 'success';
    if (success) success.hidden = state !== 'success';
    if (error) {
      error.hidden = state !== 'error';
      error.textContent = state === 'error' ? message : '';
    }
    if ((state === 'success' || state === 'error') && !form.closest('[role="dialog"]')) {
      var feedback = state === 'success' ? success : error;
      if (feedback) {
        feedback.setAttribute('tabindex', '-1');
        window.requestAnimationFrame(function () {
          if (form.getAttribute('data-pu-form-state') === state) feedback.focus();
        });
      }
    }
  }

  function buildFields(form) {
    return allowedFields.reduce(function (fields, name) {
      var control = form.elements.namedItem(name);
      if (!control) return fields;
      var value = String(control.value || '').trim();
      if (!value) return fields;
      if (name === 'mobilephone') value = normalisePhone(value);
      if (name === 'im_interested_in' && allowedInterests.indexOf(value) === -1) value = 'Other';
      fields.push({ objectTypeId: '0-1', name: name, value: value });
      return fields;
    }, []);
  }

  function errorMessage(response, data) {
    if (response && response.status === 429) {
      return 'We have received several requests. Please wait a moment and try again, or call 01223 657444.';
    }
    if (data && Array.isArray(data.errors) && data.errors.some(function (item) {
      return item && (item.errorType === 'FIELD_NOT_IN_FORM_DEFINITION' || item.errorType === 'REQUIRED_FIELD');
    })) {
      return 'We could not send this form because its HubSpot fields need attention. Please call 01223 657444 or email hello@oxydise.co.uk.';
    }
    return 'We could not send this right now. Please try again, call 01223 657444 or email hello@oxydise.co.uk.';
  }

  function initForm(form) {
    if (form.dataset.puHubSpotInitialised === 'true') return;
    form.dataset.puHubSpotInitialised = 'true';
    // These forms submit through the Forms API; stop HubSpot also capturing them as non-HubSpot forms.
    form.setAttribute('data-hs-do-not-collect', 'true');
    setState(form, 'idle', '');
    var submit = form.querySelector('[data-pu-form-submit], button[type="submit"]');
    var originalLabel = submit ? submit.textContent : '';
    var syncSubmit = function () {
      if (!submit) return;
      var state = form.getAttribute('data-pu-form-state');
      submit.disabled = state === 'submitting' || state === 'success';
      submit.textContent = state === 'submitting' ? 'Sending…' : originalLabel;
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (['submitting', 'success'].indexOf(form.getAttribute('data-pu-form-state')) !== -1) return;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var phoneControl = form.elements.namedItem('mobilephone');
      if (phoneControl) {
        var phoneValue = String(phoneControl.value || '').trim();
        var normalisedPhone = normalisePhone(phoneControl.value);
        if ((phoneValue || phoneControl.required) && normalisedPhone.replace(/\D/g, '').length < 8) {
          phoneControl.setCustomValidity('Please enter a valid phone number.');
          phoneControl.reportValidity();
          phoneControl.addEventListener('input', function clearPhoneError() {
            phoneControl.setCustomValidity('');
            phoneControl.removeEventListener('input', clearPhoneError);
          });
          return;
        }
        phoneControl.setCustomValidity('');
      }

      var context = {
        pageUri: window.location.href,
        pageName: (form.dataset.puFormKind ? form.dataset.puFormKind + ' request | ' : '') + document.title
      };
      var hutk = getHubSpotCookie();
      if (hutk) context.hutk = hutk;

      setState(form, 'submitting', '');
      syncSubmit();

      var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timeout;
      var deadline = new Promise(function (resolve, reject) {
        timeout = window.setTimeout(function () {
          var timeoutError = new Error('Request timeout');
          timeoutError.name = 'TimeoutError';
          reject(timeoutError);
          if (controller) controller.abort();
        }, 15000);
      });
      var payload = JSON.stringify({
        submittedAt: Date.now(),
        fields: buildFields(form),
        context: context
      });
      var request = Promise.resolve().then(function () { return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        signal: controller ? controller.signal : undefined
      }); }).then(function (response) {
        return response.text().then(function (text) {
          var data = null;
          if (text) {
            try { data = JSON.parse(text); } catch (ignore) {}
          }
          if (!response.ok) {
            var error = new Error(errorMessage(response, data));
            error.response = response;
            error.data = data;
            throw error;
          }
          return data;
        });
      });
      Promise.race([request, deadline]).then(function () {
        form.reset();
        setState(form, 'success', '');
        form.dispatchEvent(new CustomEvent('pu:hubspot-form:success', { bubbles: true }));
      }).catch(function (error) {
        var message = error && (error.name === 'AbortError' || error.name === 'TimeoutError')
          ? 'We could not confirm your request in time. Please try again, call 01223 657444 or email hello@oxydise.co.uk.'
          : errorMessage(error && error.response, error && error.data);
        setState(form, 'error', message);
        form.dispatchEvent(new CustomEvent('pu:hubspot-form:error', { bubbles: true, detail: { message: message } }));
      }).finally(function () {
        window.clearTimeout(timeout);
        syncSubmit();
      });
    });
    if (typeof window.MutationObserver === 'function') {
      new window.MutationObserver(syncSubmit).observe(form, { attributes: true, attributeFilter: ['data-pu-form-state'] });
    }
    syncSubmit();
  }

  function initForms(root) {
    if (root.matches && root.matches('[data-pu-hubspot-form]')) initForm(root);
    root.querySelectorAll('[data-pu-hubspot-form]').forEach(initForm);
  }

  function ready() {
    if (!document.getElementById('pu-hubspot-visibility')) {
      var visibilityStyle = document.createElement('style');
      visibilityStyle.id = 'pu-hubspot-visibility';
      visibilityStyle.textContent = '[data-pu-hubspot-form] [data-pu-form-fields][hidden], [data-pu-hubspot-form] [data-pu-form-feedback][hidden] { display: none !important; }';
      document.head.appendChild(visibilityStyle);
    }
    initForms(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();

  document.addEventListener('shopify:section:load', function (event) {
    initForms(event.target);
  });
})();
